<div class="ui label warning-label">
  <span>
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 7.5V10.625M17.5 10C17.5 14.1421 14.1421 17.5 10 17.5C5.85786 17.5 2.5 14.1421 2.5 10C2.5 5.85786 5.85786 2.5 10 2.5C14.1421 2.5 17.5 5.85786 17.5 10ZM10 13.125H10.0063V13.1313H10V13.125Z"
        stroke="#2C6ECB"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  </span>

  <span class="text"
    >Please confirm that your TCC Records are accurate and up-to-date. If any
    information is incorrect, kindly click on the Add New Record button to make
    the necessary updates. However, you can send us a chat message
    <a [routerLink]="['/contractor/chat-window']" routerLinkActive="active"
      >here</a
    >
    if you have any question or feedback.</span
  >
</div>

<!-- other tcc data -->

<ng-container *ngIf="isBusinessName">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <h3 appMargin marginB="0" class="ui primary header">
      Other Tax Clearance Certificate Records
    </h3>

    <!-- for business name -->
    <button
      *isPermitted="{ id: 'TCC_RECORD_MANAGEMENT', action: 'add' }"
      class="ui tiny primary dropdown button"
      style="font-weight: 500"
      appPadding
      paddingY="4"
      suiDropdown
    >
      <div class="text">Add Tax Record</div>
      <i class="dropdown icon"></i>
      <div
        appMargin
        marginT="2"
        class="menu"
        suiDropdownMenu
        style="
          width: 200px;
          max-width: 250px;
          word-break: break-word;
          margin-left: -57px;
          border-radius: 4px;
        "
      >
        <a class="item" (click)="otherTCCRecord()">Add Other Tax Clearance</a>

        <a class="item" (click)="newRecord('TIN')"> Add FIRS Tax Clearance</a>
      </div>
    </button>
  </div>
  <div class="ui divider"></div>

  <app-advanced-search-filter
    [filter]="filterTwo"
    (onSearch)="searchRecordsTwo($event)"
    (onDisplayRows)="displayRecordsTwo($event)"
    (onSort)="sortRecordsTwo($event)"
    [hasSort]="true"
    [hasDisplayRows]="true"
    [hasAdvancedSearch]="true"
    [hasFilters]="true"
  ></app-advanced-search-filter>

  <div class="ui vertical basic segment" *ngIf="successTwo || errorTwo">
    <esl-message-toast [(message)]="errorTwo"></esl-message-toast>
    <esl-message-toast
      [(message)]="successTwo"
      [messageType]="'success'"
    ></esl-message-toast>
  </div>
  <div class="ui vertical segment" id="scroll-container">
    <div class="ui secondary sub pointing menu" appMargin marginB="4">
      <div
        class="ui item"
        [routerLink]="['/contractor/company/record']"
        routerLinkActive="active"
        [queryParams]="{ documentStatus: 'verified' }"
      >
        Verified
        <div class="ui blue label mini circular">
          {{ otherCompanyTcc?.length || 0 }}
        </div>
      </div>
      <div
        class="ui item"
        [routerLink]="['/contractor/company/record']"
        routerLinkActive="active"
        [queryParams]="{ documentStatus: 'pending' }"
      >
        Pending Verification
        <div class="ui blue label mini circular">
          {{ pendingArray?.length || 0 }}
        </div>
      </div>
      <div
        class="ui item"
        [routerLink]="['/contractor/company/record']"
        routerLinkActive="active"
        [queryParams]="{ documentStatus: 'history' }"
      >
        History
        <div class="ui blue label mini circular">
          {{ allHistory?.length || 0 }}
        </div>
      </div>
    </div>
    <div
      class="ui vertical basic segment"
      [ngClass]="{ loading: pending }"
      appMargin="0"
      appPadding="0"
    >
      <div
        class="ui vertical basic segment"
        [ngClass]="{ loading: pendingTwo }"
        appMargin="0"
        appPadding="0"
      >
        <div *ngIf="documentStatus === 'verified'">
          <app-admin-verified-company-row
            [department]="s"
            [isBusinessName]="isBusinessName"
            *ngFor="let s of otherCompanyTcc"
          ></app-admin-verified-company-row>
        </div>
        <div *ngIf="documentStatus === 'history'">
          <app-admin-history-company-row
            [department]="s"
            [isBusinessName]="isBusinessName"
            *ngFor="let s of allHistory"
          ></app-admin-history-company-row>
        </div>
        <div *ngIf="documentStatus === 'pending'">
          <app-admin-history-company-row
            [department]="s"
            [isBusinessName]="isBusinessName"
            *ngFor="let s of pendingArray"
          ></app-admin-history-company-row>
        </div>

        <div
          class="ui segment"
          appMargin
          marginT="16px"
          *ngIf="
            otherCompanyTcc &&
            otherCompanyTcc.length < 1 &&
            documentStatus === 'verified'
          "
        >
          <esl-empty
            [description]="
              'Click the Add Tax Record button above to see them here'
            "
            imgType="illustration"
          ></esl-empty>
        </div>
        <div
          class="ui segment"
          appMargin
          marginT="16px"
          *ngIf="
            allHistory && allHistory.length < 1 && documentStatus === 'history'
          "
        >
          <esl-empty
            [description]="
              'Click the Add Tax Record button above to see them here'
            "
            imgType="illustration"
          ></esl-empty>
        </div>
        <div
          class="ui segment"
          appMargin
          marginT="16px"
          *ngIf="
            pendingArray &&
            pendingArray.length < 1 &&
            documentStatus === 'pending'
          "
        >
          <esl-empty
            [description]="
              'Click the Add Tax Record button above to see them here'
            "
            imgType="illustration"
          ></esl-empty>
        </div>
      </div>

      <div class="ui vertical basic segment">
        <div class="ui two column grid">
          <div class="column middle aligned">
            <div class="ui medium labeled button">
              <div class="records-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M10 1C13.866 1 17 2.79086 17 5C17 7.20914 13.866 9 10 9C6.13401 9 3 7.20914 3 5C3 2.79086 6.13401 1 10 1ZM15.694 9.13079C16.1576 8.86588 16.6044 8.54736 17 8.17775V10C17 12.2091 13.866 14 10 14C6.13401 14 3 12.2091 3 10V8.17775C3.3956 8.54736 3.84244 8.86588 4.30604 9.13079C5.83803 10.0062 7.85433 10.5 10 10.5C12.1457 10.5 14.162 10.0062 15.694 9.13079ZM3 13.1777V15C3 17.2091 6.13401 19 10 19C13.866 19 17 17.2091 17 15V13.1777C16.6044 13.5474 16.1576 13.8659 15.694 14.1308C14.162 15.0062 12.1457 15.5 10 15.5C7.85433 15.5 5.83803 15.0062 4.30604 14.1308C3.84244 13.8659 3.3956 13.5474 3 13.1777Z"
                    fill="#86879D"
                  />
                </svg>
              </div>
              <a
                *ngIf="documentStatus === 'history'"
                class="ui basic label records-text"
                >{{ allHistory?.length }} Record(s)</a
              >
              <a
                *ngIf="documentStatus === 'pending'"
                class="ui basic label records-text"
                >{{ pendingArray?.length }} Record(s)</a
              >
              <a
                *ngIf="documentStatus === 'verified'"
                class="ui basic label records-text"
                >{{ totalItemsTwo }} Record(s)</a
              >
            </div>
          </div>
          <div
            class="column right aligned pagination menu"
            style="margin-left: auto"
          >
            <sui-pagination
              class="small"
              [collectionSize]="totalItemsTwo"
              [pageSize]="rowsTwo"
              [maxSize]="maxSizeTwo"
              [hasEllipses]="false"
              [page]="currentPageTwo"
              (pageChange)="nextPageTwo($event)"
            >
            </sui-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<!-- firs data -->
<div *ngIf="(isBusinessName && companyTcc.length > 0) || !isBusinessName">
  <div fxLayout="row" fxLayoutAlign="space-between center">
    <h3 appMargin marginB="0" class="ui primary header">
      FIRS Tax Clearance Certificate Records
    </h3>
    <ng-container *ngIf="!isBusinessName">
      <button
        *isPermitted="{ id: 'TCC_RECORD_MANAGEMENT', action: 'add' }"
        (click)="newRecord('TIN')"
        class="ui tiny primary button"
        style="font-weight: 500"
        appPadding
        paddingY="4"
      >
        Add New Record
      </button>
    </ng-container>
  </div>
  <div class="ui divider"></div>

  <app-advanced-search-filter
    [filter]="filter"
    (onSearch)="searchRecords($event)"
    (onDisplayRows)="displayRecords($event)"
    (onSort)="sortRecords($event)"
    [hasSort]="true"
    [hasDisplayRows]="true"
    [hasAdvancedSearch]="true"
    [hasFilters]="true"
  ></app-advanced-search-filter>

  <div class="ui vertical basic segment" *ngIf="success || error">
    <esl-message-toast [(message)]="error"></esl-message-toast>
    <esl-message-toast
      [(message)]="success"
      [messageType]="'success'"
    ></esl-message-toast>
  </div>

  <div
    class="ui vertical basic segment"
    [ngClass]="{ loading: pending }"
    appMargin="0"
    appPadding="0"
  >
    <app-admin-company-row
      [department]="s"
      *ngFor="let s of companyTcc"
    ></app-admin-company-row>

    <!-- <app-no-record-found
    *ngIf="companyTcc && companyTcc.length < 1"
  ></app-no-record-found> -->

    <div
      class="ui segment"
      appMargin
      marginT="16px"
      *ngIf="companyTcc && companyTcc.length < 1"
    >
      <esl-empty
        [description]="'Click the Add Tax Record button above to see them here'"
        imgType="illustration"
      ></esl-empty>
    </div>
  </div>

  <div class="ui vertical basic segment">
    <div class="ui two column grid">
      <div class="column middle aligned">
        <div class="ui medium labeled button">
          <div class="records-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M10 1C13.866 1 17 2.79086 17 5C17 7.20914 13.866 9 10 9C6.13401 9 3 7.20914 3 5C3 2.79086 6.13401 1 10 1ZM15.694 9.13079C16.1576 8.86588 16.6044 8.54736 17 8.17775V10C17 12.2091 13.866 14 10 14C6.13401 14 3 12.2091 3 10V8.17775C3.3956 8.54736 3.84244 8.86588 4.30604 9.13079C5.83803 10.0062 7.85433 10.5 10 10.5C12.1457 10.5 14.162 10.0062 15.694 9.13079ZM3 13.1777V15C3 17.2091 6.13401 19 10 19C13.866 19 17 17.2091 17 15V13.1777C16.6044 13.5474 16.1576 13.8659 15.694 14.1308C14.162 15.0062 12.1457 15.5 10 15.5C7.85433 15.5 5.83803 15.0062 4.30604 14.1308C3.84244 13.8659 3.3956 13.5474 3 13.1777Z"
                fill="#86879D"
              />
            </svg>
          </div>
          <a class="ui basic label records-text">{{ totalItems }} Record(s)</a>
        </div>
      </div>
      <div
        class="column right aligned pagination menu"
        style="margin-left: auto"
      >
        <sui-pagination
          class="mini"
          [collectionSize]="totalItems"
          [pageSize]="rows"
          [maxSize]="maxSize"
          [hasEllipses]="false"
          [page]="currentPage"
          (pageChange)="nextPage($event)"
        >
        </sui-pagination>
      </div>
    </div>
  </div>
</div>
